import { RestApplicationClient } from '../generated-types';
class WebRestApplicationClient extends RestApplicationClient {
    constructor(httpClient) {
        super(httpClient);
        this.httpClient = httpClient;
        this.httpClient = httpClient;
    }
}
export default WebRestApplicationClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2ViLXJlc3QtYXBwbGljYXRpb24tY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3V0aWwvd2ViLXJlc3QtYXBwbGljYXRpb24tY2xpZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBYyxxQkFBcUIsRUFBRSxNQUFNLG9CQUFvQixDQUFDO0FBRXZFLE1BQU0sd0JBQTRCLFNBQVEscUJBQXdCO0lBQzlELFlBQXNCLFVBQXlCO1FBQzNDLEtBQUssQ0FBQyxVQUFVLENBQUMsQ0FBQztRQURBLGVBQVUsR0FBVixVQUFVLENBQWU7UUFFM0MsSUFBSSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUM7SUFDakMsQ0FBQztDQUNKO0FBRUQsZUFBZSx3QkFBd0IsQ0FBQyJ9